import React, { useState } from 'react';
import './Signup.css';
import { Link } from "react-router-dom";
import signupImage from '../Assets/pexels-photo-9663015.jpeg';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Make sure to import CustomAlert
import logo from '../Assets/Edumonics-Logo.png';
import { API_BASE_URL } from '../config';

function Signup() {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [errorMessage, setErrorMessage] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const isOtpComplete = otp.every(val => val.trim() !== "");
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // States for managing CustomAlert
    const [passwordShown, setPasswordShown] = useState(false);  // State for showing/hiding password
    const [newPasswordShown, setNewPasswordShown] = useState(false);  // State for showing/hiding new password in reset form

    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown);
    };

    const toggleNewPasswordVisibility = () => {
        setNewPasswordShown(!newPasswordShown);
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleOtpChange = (element, index) => {
        if (isNaN(element.value)) return false; // Ensure input is numeric
        const newOtp = [...otp];
        newOtp[index] = element.value;
        setOtp(newOtp);

        // Auto-focus to next input
        if (element.nextSibling && element.value) {
            element.nextSibling.focus();
        }
    };

    const requestOtp = async () => {
        if (!validateEmail(email)) {
            setIsEmailValid(false);
            return;
        } else {
            setIsEmailValid(true);
        }
        if (password !== confirmPassword) {
            setErrorMessage('Passwords do not match');
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/signup/request-otp/?email=${email}`, {
                method: 'POST', headers: {

                },
            });

            setIsLoading(false);
            if (response.ok) {
                setShowOtpInput(true);
                alert("OTP sent to your email. Please verify to continue signup.");

            } else {
                alert(`Request OTP failed: Invalid email or User already Exists`);

            }
        } catch (error) {
            console.error('Request OTP error:', error);
            setIsLoading(false);
            alert('Request OTP error: ' + error.message);

        }
    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!isOtpComplete) {
            alert('Please fill all the OTP fields.');

            setIsLoading(false);
            return;
        }
        const otpString = otp.join("");  // Join the OTP array into a single string
        try {
            const response = await fetch(`${API_BASE_URL}/signup/parent`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name,
                    email,
                    otp: otpString,
                    password,
                }),
            });

            if (!response.ok) {
                const data = await response.json();
                alert(`Signup failed: ${data.message}`);

                setIsLoading(false);
                return;
            }

            const data = await response.json();
            localStorage.setItem('accessToken', data.access_token);
            setIsLoading(false);
            alert('Signup successful.');

            navigate('/HomePage');

        } catch (error) {
            console.error('Signup error:', error);
            setIsLoading(false);
            alert('Signup error: ' + error.message);

        }
    };



    return (<div className="signup-container">
        <div className="signup-card">
            <div className="signup-image-container">
                <img src={signupImage} alt="Signup" className="signup-image" />
            </div>
            {!showOtpInput ? (<form className="signup-form" onSubmit={(e) => {
                e.preventDefault();
                requestOtp();
            }}>
                <img src={logo} alt="logo" className="login-image" />
                {/*<h1>HPC CogniApp - For Parents</h1>*/}
                <h1>Create Account</h1>
                <input type="text" placeholder="Name" required value={name}
                    onChange={(e) => setName(e.target.value)} />
                <input
                    type="email"
                    placeholder="Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={!isEmailValid ? "invalid" : ""}
                />
                {!isEmailValid && <p className="error-message">Please enter a valid email address</p>}
                <div className="signup-action-container">
                    <button type="submit" className="signup-btn" disabled={isLoading}>Request OTP</button>
                    {isLoading && <div className="loader"></div>}
                </div>
                <p className="login-message">
                    Already have an account? <Link to="/">Log in</Link>
                </p>
            </form>) : (<form className="signup-form" onSubmit={handleOtpSubmit}>
                <h1>Enter OTP</h1>
                <div className="otp-container">
                    {otp.map((_, index) => (<input
                        key={index}
                        type="text"
                        className="otp-input"
                        maxLength="1"
                        value={otp[index] || ""}
                        onChange={e => handleOtpChange(e.target, index)}
                    />))}
                </div>
                <div className="password-field">
                    <input
                        type={passwordShown ? 'text' : 'password'}
                        placeholder="Password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <i onClick={togglePasswordVisibility}
                        style={{ position: 'absolute', right: '15px', top: '49%', transform: 'translateY(-50%)' }}>
                        {passwordShown ? <FaEye /> : <FaEyeSlash />}
                    </i>
                </div>
                <div className="password-field">
                    <input
                        type={newPasswordShown ? 'text' : 'password'}
                        placeholder="Confirm Password"
                        required
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <i onClick={toggleNewPasswordVisibility}
                        style={{ position: 'absolute', right: '15px', top: '49%', transform: 'translateY(-50%)' }}>
                        {newPasswordShown ? <FaEye /> : <FaEyeSlash />}
                    </i>
                </div>
                <div className="signup-action-container">
                    <button type="submit" className="signup-btn" disabled={isLoading}>Verify and Register
                    </button>
                    {isLoading && <div className="loader"></div>}
                </div>
                {errorMessage && <p className="error-message">{errorMessage}</p>}
            </form>)

            }
        </div>
    </div>);
}

export default Signup;
